module.exports = __webpack_public_path__ + "img/half-filled-riceball.d9663bb4.svg";